import { connect } from 'react-redux';
import { get } from 'lodash';
import { IBaseScreenStoreProps } from './base-screen.types';
import { WIDGET_NAME } from '@sitegen/common/constants';
import { getEarliestPlatform } from 'utils/platform';
import BaseScreen from './base-screen.component';
import { State } from 'widgets/free-content/root/root.reducers';

const mapStateToProps = (state: State): IBaseScreenStoreProps => {
    const platform = state.config.widgetName === WIDGET_NAME.FREE_WEEKEND
        ? getEarliestPlatform(get(state, 'event.data.platforms'))
        : null;
    return {
        platform
    };
};

export default connect(mapStateToProps)(BaseScreen);
